const transformPostType = (postType: string) => {
  const [socialMedia, post] = postType.split('_');

  if (postType.includes('pubs_tv')) return 'pubTV';
  if (postType.includes('facebook_post')) return 'facebookTimeline';

  return `${socialMedia}${post.charAt(0).toUpperCase() + post.slice(1)}`;
};
export default transformPostType;
